/**
 * Auth Types
 */
export const GetUserProfile = {
  REQUEST: 'get_user_profile_request',
  SUCCESS: 'get_user_profile_success',
  FAILED: 'get_user_profile_failed',
}

export const IsSignedIn = {
  SET_IS_SIGNED_IN: 'set_is_signed_in',
}

export const GetUsers = {
  REQUEST: 'get_users_request',
  SUCCESS: 'get_users_success',
  FAILED: 'get_users_failed',
}

export const GetUser = {
  REQUEST: 'get_user_request',
  SUCCESS: 'get_user_success',
  FAILED: 'get_user_failed',
}

export const UpdateUser = {
  REQUEST: 'update_user_request',
  SUCCESS: 'update_user_success',
  FAILED: 'update_user_failed',
}

export const DeleteUser = {
  REQUEST: 'delete_user_request',
  SUCCESS: 'delete_user_success',
  FAILED: 'delete_user_failed',
}

export const GetInfluencers = {
  REQUEST: 'get_influencers_request',
  SUCCESS: 'get_influencers_success',
  FAILED: 'get_influencers_failed',
}

export const GetInfluencer = {
  REQUEST: 'get_influencer_request',
  SUCCESS: 'get_influencer_success',
  FAILED: 'get_influencer_failed',
}

export const ChangeInfluencerStatus = {
  REQUEST: 'change_influencer_status_request',
  SUCCESS: 'change_influencer_status_success',
  FAILED: 'change_influencer_status_failed',
}
